import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import * as fromRoot from '@core/reducers/root.reducer';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, skipWhile, switchMap, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate, CanActivateChild {
  me$ = this.store.pipe(select(fromRoot.getMe));

  constructor(private store: Store<any>, private router: Router) {}

  getRole(): Observable<any> {
    return this.me$.pipe(
      skipWhile(me => !me && !me.role),
      map(me => me.role),
      take(1)
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const roles = next.data['roles'] as Array<any>;

    return this.getRole().pipe(
      switchMap(role => {
        const includes = roles.includes(role);
        if (includes) {
          if (role === 'packaging') {
            this.router.navigate(['/packaging']);
          } else if (role === 'packaging-manager') {
            this.router.navigate(['/packaging-manager']);
          }
          return of(true);
        } else {
          this.router.navigate([next.data['redirect']]);
          return of(false);
        }
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const roles = next.data['roles'] as Array<any>;

    return this.getRole().pipe(
      switchMap(role => {
        const includes = roles.includes(role);
        if (includes) {
          return of(true);
        } else {
          this.router.navigate([next.data['redirect']]);
          return of(false);
        }
      })
    );
  }
}
